<template>
  <q-card
    class="storyCardForm"
    style="width: 1280px; max-width: 100%; height: 600px; max-height: 90vh"
  >
    <q-card-section horizontal
      v-if="!hideHeader"
      class="q-pa-md text-white storyCardHeader shadow-6"
      :style="`background: ${cssVars['--outcome-primary']}`"
    >
      <h3 class="q-my-none">
        Create a Story || What have you done "to date"
        <q-btn
          flat
          round
          icon="mdi-close"
          class="float-right"
          @click="close"
          style="position: absolute; top: 10px; right: 10px"
        ></q-btn>
      </h3>
    </q-card-section>
    <q-card-section
      class="q-pa-none"
    >
      <q-form
        @submit="onSubmit"
        @reset="init"
        v-if="formData"
        class="full-height"
      >
        <div class="row full-height">
            <div class="col-6 col-md-6 q-pa-sm full-height">
              <div class="row q-pa-md">
                <div class="col-12">
                  <h4 class="q-my-none">Story Info</h4>
                </div>
                <div class="col-12 q-py-xs">
                  <div class="row items-center">
                    <span class="q-pr-sm">Title</span>
                    <div class="col q-pl-sm">
                      <q-input
                        v-model="formData.title"
                        :rules="rules.title"
                        filled
                        dense
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12 q-py-xs">
                  <div class="row items-center">
                    <span class="q-pr-sm">Specific Date Completed</span>
                    <div class="col q-pl-sm">
                      <q-input v-model="formData.completed_at" filled dense>
                        <template v-slot:prepend>
                          <q-icon name="event" />
                        </template>
                        <q-popup-proxy
                          ref="completed_at"
                          transition-show="scale"
                          transition-hide="scale"
                          :breakpoint="0"
                        >
                          <q-date
                            minimal
                            v-model="formData.completed_at"
                            default-view="Years"
                            emit-immediately
                          >
                          </q-date>
                        </q-popup-proxy>
                      </q-input>
                    </div>
                  </div>
                </div>
                <div class="col-12 q-pt-xs">
                  <div class="row items-center">
                    <q-field
                      :error-message="outcomesError"
                      :error="showOutcomesError"
                      class="full-width"
                      hide-bottom-space
                      borderless
                    >
                      <template v-slot:control>
                        <div class="col">
                          <span v-if="!isCreatingNewStoryFromAnywhere">Does this impact another outcome?</span>
                          <span v-else>Which outcome(s) does this story apply to?</span>
                        </div>
                        <div class="col-auto q-ml-sm">
                          <q-btn
                            label="Weld outcome"
                            flat
                            class="bg-grey-3 full-width q-fs"
                            dense
                            no-caps
                            @click="welOutcomes = true"
                          />
                        </div>
                      </template>
                    </q-field>
                  </div>
                </div>
                <div class="col-12 q-pb-xs">
                  <div class="row items-center">
                      <div
                        class="col-auto"
                        v-for="(outcome, index) in formData.outcomes"
                        :key="`outcome_${index}`"
                      >
                        <q-chip square class="outcomeTag">
                          {{ outcome.label }}
                          <q-icon
                            name="mdi-close"
                            class="q-ml-sm cursor-pointer"
                            color="black"
                            size="14px"
                            @click="
                        formData.outcomes = formData.outcomes.filter(
                          (o) => o.id != outcome.id
                        )
                      "
                          ></q-icon>
                        </q-chip>
                      </div>
                  </div>
                </div>
                <div class="col-12 q-py-xs">
                  <div class="row items-center">
                    <span class="q-pr-sm">Add an Image</span>
                    <div class="col q-pl-sm">
                      <q-file
                        label="Upload Image"
                        accept="image/*"
                        max-file-size="1000000"
                        v-model="newImage"
                        filled
                        dense
                        @rejected="rejectNewImage"
                        @update="newImageUploaded"
                        clearable
                      ></q-file>
                    </div>
                  </div>
                </div>
                <div class="col-12 q-py-xs">
                  <!-- <div class="row items-center"> -->
                  <span class="q-pr-sm">Description of story</span>

                  <!-- </div> -->
                </div>
                <div class="col-12 q-py-xs">
                  <!-- <div class="row items-center"> -->
                  <q-input
                    v-model="formData.description"
                    type="textarea"
                    filled
                    dense
                  ></q-input>

                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div class="col-6 bg-grey-2 col-md-6 q-pa-sm">
                <div class="row q-pa-md" v-if="!welOutcomes">
                  <div class="col-12">
                    <h4 class="q-my-none">Story Preview</h4>
                  </div>
                  <div class="col-12">
                    <storyCard style="margin: auto" :data="formData" :image-data-prop="storyCardImageData" />
                  </div>
                  <div class="col-12 q-pt-sm">
                    <q-btn
                      class="q-px-sm q-ma-xs text-negative"
                      no-caps
                      dense
                      flat
                      label="Delete"
                      text-color="negative"
                      :loading="deleting"
                      @click="deleteStory()"
                    ></q-btn>
                    <q-btn
                      class="q-px-sm bg-accent text-white float-right q-ma-xs"
                      no-caps
                      dense
                      flat
                      label="Save & Close Story"
                      :loading="saving"
                      type="submit"
                    ></q-btn>
                    <q-btn
                      class="q-px-sm bg-grey text-white float-right q-ma-xs"
                      no-caps
                      dense
                      flat
                      label="Reset"
                      type="reset"
                    ></q-btn>
                  </div>
                </div>
                <div class="row q-pa-md" v-if="welOutcomes">
                  <div class="col-12">
                    <h4 class="q-my-none">
                      Weld to an Outcome
                      <q-btn
                        icon="mdi-close"
                        @click="welOutcomes = false"
                        flat
                        round
                        class="float-right"
                        size="sm"
                      ></q-btn>
                    </h4>
                  </div>
                  <div class="col-12">
                    <q-list class="q-mt-xs q-pa-xs">
                      <q-card
                        class="categoryCard no-shadow"
                        :class="{
                        cardSelected: outcome.selected,
                      }"
                        @click="
                        !outcome.selected
                          ? (() => {formData.outcomes.push(outcome); showOutcomesError = false;})()
                          : (formData.outcomes = formData.outcomes.filter(
                              (o) => o.id != outcome.id
                            ))
                      "
                        v-for="(outcome, i) in outcomesFiltered"
                        :key="i"
                      >
                        <q-item clickable dense>
                          <div class="row justify-between items-center full-width">
                            <div class="col">
                            <span class="categoryText">
                              {{ outcome.label }}
                            </span>
                            </div>
                          </div>
                        </q-item>
                      </q-card>
                    </q-list>
                  </div>
                </div>
            </div>
        </div>
      </q-form>
    </q-card-section>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import { getCSSVars } from "@/functions/cssVars";
import moment from "moment";
import storyCard from "@/components/storyCards/storyCard.vue";
export default {
  components: { storyCard },
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
      data: "storyCard/current",
      dataLoading: "storyCard/currentLoading",
      outcomes: "outcomes/list",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
    outcomesFiltered() {
      let outcomes = this.outcomes;
      outcomes.forEach((o) => {
        if (this.formData.outcomes.find((fo) => fo.id == o.id)) {
          o.selected = true;
        } else {
          o.selected = false;
        }
      });
      return outcomes;
    },
  },
  props: {
    // Sometimes we'll want to create a new story when we're not looking at an outcome (e.g from the dashboard)
    isCreatingNewStoryFromAnywhere: {
      default: false,
    },
    hideHeader: {
      default: false,
    },
    defaultData: {
      default: null,
    },
    fromSolutionCard: {
      default: false,
    },
    solutions: {
      default: null,
    },
    storyCardId: {
      default: null,
    },
    closeFunction: {
      default: null,
    },
  },
  data: () => ({
    formData: null,
    newImage: null,
    saving: false,
    welOutcomes: false,
    deleting: false,
    outcomesError: "",
    showOutcomesError: false,
    storyCardImageData: null,

    rules: {
      title: [
        val => (val && val.length > 0) || 'A title is required',
      ]
    }
  }),
  watch: {
    data: function () {
      this.init();
    },
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
    newImage() {
      this.newImageUploaded();
    },
  },
  async mounted() {
    if (this.storyCardId || !isNaN(parseInt(this.$route.params.storyCard_id))) {
      this.loadData();
    } else {
      this.init();
    }
  },
  methods: {
    getCSSVars: getCSSVars,

    init() {
      if (
        this.data != null &&
        (this.data.id == this.$route.params.storyCard_id || this.data.id == this.storyCardId)
      ) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {
          title: this.defaultData ? this.defaultData.title : "",
          completed_at: moment().format("YYYY-MM-DD"),
          imgUrl: this.defaultData ? this.defaultData.imageUrl : null,
          description: this.defaultData ? this.defaultData.description : "",
          outcomes: this.defaultData
            ? this.defaultData.outcomes.map((val) => {
                return {
                  id: val.outcomes_id,
                  name: val.name,
                  label: val.outcomeLabel,
                };
            })
            : [],
        };
        if (this.selectedOutcome && !this.defaultData && !this.isCreatingNewStoryFromAnywhere) {
          this.formData.outcomes.push(this.selectedOutcome);
        }
      }
    },

    loadData() {
      this.$store.dispatch("storyCard/loadByID", {
        id: this.storyCardId
          ? this.storyCardId
          : this.$route.params.storyCard_id,
      });
    },

    async onSubmit() {
      if (this.formData.outcomes.length <= 0) {
        this.showOutcomesError = true;
        this.outcomesError = "Please weld at least one outcome to this story";
        return;
      }
      this.showOutcomesError = false;
      this.formData.sustainability_business_id = this.currentUserData.sustainabilityBusiness_id
      this.formData.outcome_ids = this.formData.outcomes.map((outcome) => outcome.id);

      await this.save();
    },

    async save() {
      this.saving = true;

      if (this.solutions && this.solutions.length >= 1) {
        this.formData.solution_id = this.solutions[0].id;
      }

      try {
        // If we are editing an existing story
        let response;
        if(this.formData.id) {
          response = await this.$store.dispatch(
            "storyCard/updateExisting",
            this.formData
          );
        } else {
          response = await this.$store.dispatch(
            "storyCard/createNew",
            this.formData
          );
        }

        this.$q.notify({
          position: "top-right",
          type: response.Result === "Success" ? "positive" : "negative",
          message: response.Response.message,
        });

        this.$emit("reloadData");
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later",
        });
      }
      this.saving = false;
      this.close();
    },

    handleRoute() {},

    rejectNewImage(rejectedEntries) {
      this.$q.notify({
        position: "top-right",
        type: "negative",
        message: `${rejectedEntries.length} file(s) did not pass validation constraints (Max 1mb)`,
      });
    },
    newImageUploaded() {
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          this.formData.imgUrl = reader.result;
          this.storyCardImageData = reader.result;
        },
        false
      );

      if (this.newImage) {
        reader.readAsDataURL(this.newImage);
      } else {
        this.formData.imgUrl = this.data.imgUrl;
      }
    },
    close() {
      if (typeof this.closeFunction == "function") {
        this.closeFunction();
      } else {
        this.$router.push(
          `${this.$route.path.split(`/${this.$route.params.storyCard_id}`)[0]}`
        );
      }
    },
    async deleteStory() {
      let result = await this.$swal({
        title: "Warning",
        text: "You are about to delete this Story Card. This is irreversible, did you want to continue?",
        type: "warning",
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      });

      if (result.value) {
        this.deleting = true;

        try {
          let response = await this.$store.dispatch("storyCard/delete", {
            id: this.formData.id,
          });

          this.$q.notify({
            position: "top-right",
            type: response.Result == "Success" ? "positive" : "negative",
            message: response.Response.Message,
          });

          this.$emit("reloadData");
          this.close();
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an error, Please try again later",
          });
        }
        this.deleting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.storyCardForm {
  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: $accent;
  }

  .outcomeTag {
    font-weight: 600;
    background: #ecfbff;
  }

  .storyCardHeader {
    h3 {
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 30px;
    }
  }

  .categoryCard {
    margin-bottom: 10px;

    .categoryText {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
    }
  }

  .cardSelected {
    background-color: $primaryFaded;
  }
}
</style>
